var React = require('react');

function Moon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"moon"),React.createElement("path",{"d":"M864,718.65C791.64,822,671.73,889.55,536,889.55c-220.91,0-400-179.09-400-400,0-176.17,113.9-325.75,272.07-379.1A398.14,398.14,0,0,0,336,339.55c0,220.91,179.09,400,400,400A399.16,399.16,0,0,0,864,718.65Z","key":1})]);
}

Moon.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 1000 1000"};

module.exports = Moon;

Moon.default = Moon;
